import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { GalaxyNavLayoutComponent } from './nav-layout.component';
export { GalaxyNavLayoutComponent };

import { GalaxyNavItemListComponent } from './components/nav-item-list/nav-item-list.component';
export { GalaxyNavItemListComponent };

import { GalaxyNavItemListItemsDirective } from './directives/nav-item-list-items.directive';
export { GalaxyNavItemListItemsDirective };

import { GalaxyNavHeaderDirective } from './directives/nav-header.directive';
export { GalaxyNavHeaderDirective };

import { GalaxyNavFooterDirective } from './directives/nav-footer.directive';
export { GalaxyNavFooterDirective };

import { GalaxyNavSubheaderDirective } from './directives/nav-subheader.directive';
export { GalaxyNavSubheaderDirective };

import { GalaxyNavItemAccessoryDirective } from './directives/nav-item-accessory.directive';
export { GalaxyNavItemAccessoryDirective };

export const MODULE_IMPORTS = [CommonModule, RouterModule, MatIconModule, MatRippleModule, TranslateModule];

export const MODULE_DECLARATIONS = [
  GalaxyNavLayoutComponent,
  GalaxyNavHeaderDirective,
  GalaxyNavFooterDirective,
  GalaxyNavSubheaderDirective,
  GalaxyNavItemAccessoryDirective,
  GalaxyNavItemListItemsDirective,
  GalaxyNavItemListComponent,
];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [
    GalaxyNavLayoutComponent,
    GalaxyNavHeaderDirective,
    GalaxyNavFooterDirective,
    GalaxyNavSubheaderDirective,
    GalaxyNavItemAccessoryDirective,
    GalaxyNavItemListItemsDirective,
    GalaxyNavItemListComponent,
  ],
})
export class GalaxyNavLayoutModule {}
